module.exports = __webpack_public_path__ + "img/W5.4662fe46.png";